<template>
  <div class="answers">
    <div
      v-for="answer in answers"
      @click="updateSelection(answer.answer_id)"
      :key="`answer-id-${answer.answer_id}`"
      :class="[
        'answers__selection',
        isSelected(answer) && 'answers__selection--selected',
      ]"
    >
      <button class="answers__select">
        <OptionSelectedIcon
          v-if="isSelected(answer)"
          class="answers__icon answers__icon--filled"
        />
        <OptionIcon v-else class="answers__icon" />
      </button>
      <div class="answers__answer">
        <span v-html="answer.content"></span>
      </div>
    </div>
    <div class="answers__btn-wrapper">
      <div
        :style="
          currentQuestion.question_id === firstQuestion.question_id
            ? 'pointer-events: none; opacity: 0.5'
            : ''
        "
      >
        <button
          @click="previousQuestion()"
          class="answers__btn answers__btn__prev"
        >
          <RightCaretIcon class="answers__btn__prev--icon" />
          Previous
        </button>
      </div>
      <div
        :style="
          !currentSelection.length && 'pointer-events: none; opacity: 0.5'
        "
      >
        <button
          @click="answerQuestion()"
          class="answers__btn answers__btn__next"
        >
          {{
            currentQuestion.question_id !== lastQuestion.question_id
              ? 'Next'
              : 'Finish'
          }}
          <RightCaretIcon class="answers__btn__next--icon" />
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import RightCaretIcon from '@/assets/icons/navigation/right_caret.svg'
import OptionIcon from '@/assets/icons/course/quiz/option.svg'
import OptionSelectedIcon from '@/assets/icons/course/quiz/option_selected.svg'

export default {
  name: 'Answers',
  components: {
    RightCaretIcon: { ...RightCaretIcon, name: 'RightCaretIcon' },
    OptionIcon: { ...OptionIcon, name: 'OptionIcon' },
    OptionSelectedIcon: { ...OptionSelectedIcon, name: 'OptionSelectedIcon' },
  },
  data() {
    return {
      currentSelection: [],
    }
  },
  props: {
    currentQuestion: {
      type: Object,
      required: true,
    },
    lastQuestion: {
      type: Object,
      required: true,
    },
    firstQuestion: {
      type: Object,
      required: true,
    },
  },
  computed: {
    answers() {
      const { answers } = this.currentQuestion
      return answers
    },
  },
  methods: {
    updateSelection(id) {
      if (!this.currentSelection.includes(id)) {
        this.currentSelection = [...this.currentSelection, id]
      } else {
        this.currentSelection = this.currentSelection.filter(
          selectionId => selectionId !== id
        )
      }
    },
    isSelected(answer) {
      return this.currentSelection.includes(answer.answer_id)
    },
    previousQuestion() {
      this.$scrollTo('.quiz-content__wrapper', 10, {
        container: '.quiz-content__modal',
        offset: 0,
      })
      this.$emit('movePreviousQuestion', this.currentSelection)
    },
    answerQuestion() {
      this.$scrollTo('.quiz-content__wrapper', 10, {
        container: '.quiz-content__modal',
        offset: 0,
      })
      this.$emit('answerSelected', this.currentSelection)
      this.currentSelection = []
    },
  },
  mounted() {
    this.currentSelection = this.currentQuestion.answers.reduce(
      (acc, answer) => {
        if (answer.is_selected_by_user) acc.push(answer.answer_id)
        return acc
      },
      []
    )
  },
}
</script>

<style lang="scss">
.answers {
  margin: 20px 0 0 0;
  @include desktop {
    margin: 0;
    padding: 0 20px 15px 20px;
  }
  &__selection {
    display: flex;
    margin: 0 0 20px 0;
    padding: 20px;
    border: 4px solid var(--border-gray);
    cursor: pointer;
    @include desktop {
      padding: 25px 60px 15px 25px;
    }
    &--selected {
      border-color: var(--green);
    }
  }
  &__select {
    background: none;
    border: none;
    height: 34px;
    max-width: 34px;
    padding: 15px;
    margin: 0;
    position: relative;
    &:hover {
      cursor: pointer;
    }
  }
  &__icon {
    position: absolute;
    top: -1px;
    right: -1px;
    &--filled {
      fill: var(--green);
    }
  }
  &__answer {
    color: var(--dark-gray);
    font-size: 1rem;
    margin: 0 0 0 20px;
    @include desktop {
      font-size: 18px;
    }
  }
  &__btn-wrapper {
    display: flex;
    justify-content: space-between;
    margin-top: 30px;
  }
  &__btn {
    background: transparent;
    border: 3px solid var(--orange);
    border-radius: 200px;
    font-weight: bold;
    text-transform: uppercase;
    display: flex;
    align-items: center;
    justify-content: space-between;
    transition: 0.3s all ease;
    @include desktop {
      font-size: 22px;
      padding: 15px 25px;
    }
    cursor: pointer;
    &:hover {
      background: var(--orange);
      color: var(--white);
      svg {
        fill: var(--white);
      }
    }
    &__next--icon {
      margin: 0 0 0 20px;
      transition: 0.3s all ease;
    }
    &__prev--icon {
      margin: 0 20px 0 0;
      transition: 0.3s all ease;
      transform: rotate(180deg);
    }
  }
  img {
    max-width: 450px;
  }
}
</style>
